// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3c4f4cf3","667":"0b2fa6c0"}[chunkId] + ".chunk.js";
};